export default "__VITE_ASSET__51791e4c__"